import { Box, Divider, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';

import AuthTypeField from './AuthTypeField';
import AuthorityField from './AuthorityField';
import ClientIdField from './ClientIdField';
import RedirectUriField from './RedirectUriField';
import ResponseTypeField from './ResponseTypeField';
import ScopeField from './ScopeField';
import PostLogoutRedirectUriField from './PostLogoutRedirectUriField';
import ResponseModeField from './ResponseModeField';
import IntrospectionEndpointField from './IntrospectionEndpointField';
import type { OrganizationUpdateRequest } from '@/actions/org';

interface AuthFieldsProps {
  values: OrganizationUpdateRequest;
  setValue: <K extends keyof OrganizationUpdateRequest>(
    key: K,
    value: OrganizationUpdateRequest[K],
  ) => void;
  setChanged: () => void;
  errors: Partial<Record<keyof OrganizationUpdateRequest, string>>;
}

function AuthFields({
  values,
  setValue,
  setChanged,
  errors,
}: AuthFieldsProps): React.JSX.Element {
  return (
    <Box sx={{ width: '100%' }}>
      <Typography variant='h6' sx={{ mt: 3 }}>
        Auth
      </Typography>
      <Divider sx={{ my: 2 }} />

      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 6 }}>
          <AuthTypeField
            value={values.auth_type ?? null}
            setValue={(v) => {
              setValue('auth_type', v);
              setChanged();
            }}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <AuthorityField
            value={values.authority ?? ''}
            error={errors.authority}
            setValue={(v) => {
              setValue('authority', v);
              setChanged();
            }}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <ClientIdField
            value={values.client_id ?? ''}
            setValue={(v) => {
              setValue('client_id', v);
              setChanged();
            }}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <RedirectUriField
            value={values.redirect_uri ?? ''}
            error={errors.redirect_uri}
            setValue={(v) => {
              setValue('redirect_uri', v);
              setChanged();
            }}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <ResponseTypeField
            value={values.response_type ?? ''}
            setValue={(v) => {
              setValue('response_type', v);
              setChanged();
            }}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <ScopeField
            value={values.scope ?? ''}
            setValue={(v) => {
              setValue('scope', v);
              setChanged();
            }}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <PostLogoutRedirectUriField
            value={values.post_logout_redirect_uri ?? ''}
            error={errors.post_logout_redirect_uri}
            setValue={(v) => {
              setValue('post_logout_redirect_uri', v);
              setChanged();
            }}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <ResponseModeField
            value={values.response_mode ?? ''}
            setValue={(v) => {
              setValue('response_mode', v);
              setChanged();
            }}
          />
        </Grid>
        <Grid size={12}>
          <IntrospectionEndpointField
            value={values.introspection_endpoint ?? ''}
            error={errors.introspection_endpoint}
            setValue={(v) => {
              setValue('introspection_endpoint', v);
              setChanged();
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
}

export default AuthFields;

